<hpf-module-en-savoir-plus-form
	[moduleEnSavoirPlus]="moduleEnSavoirPlus"
	[loading]="moduleEnSavoirPlus.isNew()"
	(update)="onUpdate()"
	(delete)="onDelete()"
></hpf-module-en-savoir-plus-form>
